import { DatePipe, DecimalPipe, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NavMenuService } from '../../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { Tc, TcPerfilUsuarioEnum } from '../../../../core/_infrastructure/types/common';
import { EnumCodigosTwTcAcciones } from '../../../../_importacion/solicitudes/types/enum';
import { SolicitudExService } from '../../datosbasicos/datosbasicosEx.service';
import { CopiaCFExService } from './copiaCFEx.service';
import { CopiaCertificadoExViewModel, SolicitudCopiaCertificadoExViewModel, TcEstadoCopiaCFExEnum } from './copiaCFEx.types';
import { AuxEnvioExViewModel } from '../envioEx.types';
import { EnumIdsTcEstadoCertificadoFitoEx } from '../../types/enum';

@Component({
    selector: 'app-copiacfex-edit',
    templateUrl: './copiaCFEx-edit.component.html',
})
export class CopiaCFExEditComponent extends ComponentBase implements OnInit {
    editMode = false;
    codigoSolicitud: string;
    tituloTipoSolicitudEx: string;
    tituloEstadoSolicitudEx: string;
    tituloEstadoCertificadoFitoEx: string;
    tituloEstadoCopia: string;
    codigoTipoSolicitud: string;
    IdEstadoSolicitudEx: number;
    IdEstadoCertificadoFitoEx: number;
    IdEstadoCopia: number;
    campoObligatorio = true;
    campoBultosObligatorio = false;

    listTipo: Tc[];

    solicitudCopiaCertificadoEx: SolicitudCopiaCertificadoExViewModel;
    selectedCopiaCertificadoEx: CopiaCertificadoExViewModel;

    IdSolicitudEx: number;

    habilitarGuardar = true;
    habilitarEdicion = true;
    habilitarImprimir = false;
    habilitarAnular = false;
    habilitarEmitir = false;

    habilitarDecision = false;

    visibilitySpinner = false;
    visibilitySpinnerImprimir = false;
    visibilitySpinnerAnular = false;
    visibilitySpinnerEmitir = false;
    visibilityDecision = false;
    esClonada = false;

    public isCollapsedDatosBasicos = false;
    public isCollapsedOtrosDatos = false;
    public isCollapsedDecision = false;

    constructor(
        public datepipe: DatePipe,
        public decimalPipe: DecimalPipe,
        private activatedRoute: ActivatedRoute,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private navMenuService: NavMenuService,
        private solicitudExService: SolicitudExService,
        private copiaCFEXService: CopiaCFExService,
        private _location: Location,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.solicitudCopiaCertificadoEx = new SolicitudCopiaCertificadoExViewModel();
        this.selectedCopiaCertificadoEx = new CopiaCertificadoExViewModel();
    }

    ngOnInit() {
        this.globalService.getTiposSolicitudCopia().subscribe(res => {
            this.listTipo = res;
        });

        this.createForm();

        let id = this.activatedRoute.snapshot.params['id'];
        let idCopia = this.activatedRoute.snapshot.params['idCopia'];

        this.IdSolicitudEx = id;
        //Para que se abran las pestañas de la solicitud
        this.guardRefreshPage(id);

        //EDIT DE COPIA
        if (idCopia) {
            this.ManageEditCopia(id, idCopia);
        }

        //ALTA DE COPIA
        else {
            this.ManageNewCopia(id);
        }
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudExportacion.Id) || this.navMenuService.currentSolicitudExportacion.Id !== id) {
            this.solicitudExService.getSolicitudEx(id).subscribe(result => {
                this.navMenuService.currentSolicitudExportacion = result;
            });
        }
    }

    private ManageNewCopia(id: number) {
        this.copiaCFEXService.getSolicitudCopiaCertificadoEx(id).subscribe(result => {
            this.solicitudCopiaCertificadoEx = result;

            this.habilitarGuardar =
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_COPIA_CF, this.solicitudCopiaCertificadoEx.IdEstadoSolicitudEx, undefined)
                    .Visible && this.solicitudCopiaCertificadoEx.IdEstadoCertificadoFitoEx === EnumIdsTcEstadoCertificadoFitoEx.ID_FINALIZADO_CONFORME;

            if (!this.habilitarGuardar) {
                //metodo para deshabilitar los controles
                this.DisableControlsConsulta();
            }

            this.IdEstadoSolicitudEx = this.solicitudCopiaCertificadoEx.IdEstadoSolicitudEx;
            this.IdEstadoCopia = TcEstadoCopiaCFExEnum.Nueva;
            this.codigoSolicitud = this.solicitudCopiaCertificadoEx.CodigoSolicitud;
            this.codigoTipoSolicitud = this.solicitudCopiaCertificadoEx.CodigoTipoSolicitud;
            this.tituloTipoSolicitudEx = this.solicitudCopiaCertificadoEx.IdTipoSolicitudExDescripcion;
            this.tituloEstadoSolicitudEx = this.solicitudCopiaCertificadoEx.IdEstadoSolicitudExDescripcion;
            this.tituloEstadoCertificadoFitoEx = this.solicitudCopiaCertificadoEx.IdEstadoCertificadoFitoExDescripcion;
            this.tituloEstadoCopia = 'Nueva';

            this.form.patchValue({
                NumCertificadoOriginal: this.solicitudCopiaCertificadoEx.NumeroCertificado,
                NumCopia: this.solicitudCopiaCertificadoEx.NumCopia,
                IdDecision: 'A', //es un campo requiered para el inspector. No viaja a servidor
            });

            this.isCollapsedDatosBasicos = false;
        });
    }

    private ManageEditCopia(id: number, idCopia: number) {
        //this.editTitle = 'Editar';
        //this.editMode = true;

        this.copiaCFEXService.getSolicitudCopiaCertificadoEx(id).subscribe(result => {
            this.solicitudCopiaCertificadoEx = result;

            this.IdEstadoSolicitudEx = this.solicitudCopiaCertificadoEx.IdEstadoSolicitudEx;
            //Solicitud estado CF TwTcEstadoCertificadoFitoEx --1 Pendiente; --2 Finalizado Conforme; --3 Anulado; --4 Anulado y sustituido
            this.IdEstadoCertificadoFitoEx = this.solicitudCopiaCertificadoEx.IdEstadoCertificadoFitoEx;
            this.codigoSolicitud = this.solicitudCopiaCertificadoEx.CodigoSolicitud;
            this.codigoTipoSolicitud = this.solicitudCopiaCertificadoEx.CodigoTipoSolicitud;
            this.tituloTipoSolicitudEx = this.solicitudCopiaCertificadoEx.IdTipoSolicitudExDescripcion;
            this.tituloEstadoSolicitudEx = this.solicitudCopiaCertificadoEx.IdEstadoSolicitudExDescripcion;
            this.tituloEstadoCertificadoFitoEx = this.solicitudCopiaCertificadoEx.IdEstadoCertificadoFitoExDescripcion;

            this.isCollapsedDatosBasicos = false;

            this.copiaCFEXService.getCopia(idCopia).subscribe(result => {
                this.selectedCopiaCertificadoEx = result;

                //Copia estado propio TcEstadoCopiaCfEx --1 Nueva; --2 Conforme; --3 No Conforme; --4 Anulada
                this.IdEstadoCopia = this.selectedCopiaCertificadoEx.IdEstadoCopiaCfEx;
                this.tituloEstadoCopia = this.selectedCopiaCertificadoEx.IdEstadoCopiaCfExDescripcion;

                this.updateForm(this.selectedCopiaCertificadoEx);

                if (this.solicitudCopiaCertificadoEx.IdEstadoCertificadoFitoEx === EnumIdsTcEstadoCertificadoFitoEx.ID_FINALIZADO_CONFORME) {
                    this.habilitarGuardar =
                        this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_COPIA_CF, this.solicitudCopiaCertificadoEx.IdEstadoSolicitudEx).Visible &&
                        this.selectedCopiaCertificadoEx.IdEstadoCopiaCfEx === TcEstadoCopiaCFExEnum.Nueva;

                    this.habilitarEmitir =
                        this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.IMPRIMIR_COPIA_CF, this.solicitudCopiaCertificadoEx.IdEstadoSolicitudEx).Visible &&
                        this.selectedCopiaCertificadoEx.IdEstadoCopiaCfEx === TcEstadoCopiaCFExEnum.Conforme &&
                        this.selectedCopiaCertificadoEx.FechaExpedicion === null;

                    this.habilitarAnular =
                        this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.IMPRIMIR_COPIA_CF, this.solicitudCopiaCertificadoEx.IdEstadoSolicitudEx).Visible &&
                        this.selectedCopiaCertificadoEx.IdEstadoCopiaCfEx === TcEstadoCopiaCFExEnum.Conforme &&
                        this.selectedCopiaCertificadoEx.FechaExpedicion !== null;

                    this.habilitarImprimir =
                        this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.IMPRIMIR_COPIA_CF, this.solicitudCopiaCertificadoEx.IdEstadoSolicitudEx).Visible &&
                        this.selectedCopiaCertificadoEx.IdEstadoCopiaCfEx === TcEstadoCopiaCFExEnum.Conforme &&
                        this.selectedCopiaCertificadoEx.FechaExpedicion !== null;
                } else {
                    this.habilitarGuardar = false;
                    this.habilitarEmitir = false;
                    this.habilitarAnular = false;
                    this.habilitarImprimir = false;
                }

                if (!this.habilitarGuardar) {
                    //metodo para deshabilitar los controles
                    this.DisableControlsConsulta();
                }

                if (!this.isSolicitante) {
                    this.DisableControlsConsulta();
                }

                this.editMode = this.habilitarGuardar || this.habilitarEmitir || this.habilitarAnular;

                this.visibilityDecision = result?.IdEstadoCopiaCfEx !== TcEstadoCopiaCFExEnum.Anulada;

                this.habilitarDecision = this.editMode && this.isInspector && result?.IdEstadoCopiaCfEx === TcEstadoCopiaCFExEnum.Nueva;

                //@author jlht Los radio button no funcionan con [disabled]="true" aunque lo diga la documentación, hay que deshabilitarlos así
                if (this.habilitarDecision === true) {
                    this.form.controls.IdDecision.enable();
                } else {
                    this.form.controls.IdDecision.disable();
                }
            });
        });
    }

    private DisableControlsConsulta() {
        this.form.controls['IdTipoSolicitudCopiaEx'].disable();
        this.form.controls['Observaciones'].disable();
    }

    createForm() {
        this.form = this.fb.group({
            IdTipoSolicitudCopiaEx: [null, Validators.required],
            Codigo: null,
            NumCopia: null,
            NumCertificadoOriginal: [null],
            Observaciones: [null],
            Estado: [null],
            FechaPeticion: [null],
            FechaInspeccion: [null],
            FechaExpedicion: [null],
            FechaAnulacion: [null],
            IdDecision: [{ value: null, disabled: true }],
        });

        if (this.isInspector) {
            this.addValidator('IdDecision', Validators.required);
        }
    }

    updateForm(copia: CopiaCertificadoExViewModel) {
        this.form.setValue({
            IdTipoSolicitudCopiaEx: copia.IdTipoSolicitudCopiaEx,
            Codigo: copia.Codigo,
            NumCopia: copia.NumCopia,
            NumCertificadoOriginal: this.solicitudCopiaCertificadoEx.NumeroCertificado,
            Observaciones: copia.Observaciones,
            Estado: copia.IdEstadoCopiaCfExDescripcion,
            FechaPeticion: this.datepipe.transform(copia.FechaPeticionCopia, 'dd/MM/yyyy'),
            FechaInspeccion: this.datepipe.transform(copia.FechaInspeccionCopia, 'dd/MM/yyyy'),
            FechaExpedicion: this.datepipe.transform(copia.FechaExpedicion, 'dd/MM/yyyy'),
            FechaAnulacion: this.datepipe.transform(copia.FechaAnulacion, 'dd/MM/yyyy'),
            IdDecision:
                copia.IdEstadoCopiaCfEx === TcEstadoCopiaCFExEnum.Conforme ? 'A' : copia.IdEstadoCopiaCfEx === TcEstadoCopiaCFExEnum.NoConforme ? 'R' : null,
        });
    }

    ManageEstadoCopia(copia: CopiaCertificadoExViewModel) {
        if (this.form.value.IdDecision === 'A') {
            copia.IdEstadoCopiaCfEx = TcEstadoCopiaCFExEnum.Conforme;
        } else if (this.form.value.IdDecision === 'R') {
            copia.IdEstadoCopiaCfEx = TcEstadoCopiaCFExEnum.NoConforme;
        } else {
            copia.IdEstadoCopiaCfEx = this.selectedCopiaCertificadoEx.IdEstadoCopiaCfEx;
        }
    }

    saveCopia() {
        this.visibilitySpinner = true;
        this.onSubmit();
    }

    emitirCopia() {
        this.visibilitySpinnerEmitir = true;

        let model: AuxEnvioExViewModel = new AuxEnvioExViewModel();
        model.IdSolicitudEx = this.selectedCopiaCertificadoEx.IdSolicitudEx;
        model.IdCopia = this.selectedCopiaCertificadoEx.Id;
        model.IdUsuario = this.loggedInUser!.Id;
        model.IdIdioma = this.solicitudCopiaCertificadoEx.IdIdioma;

        this.copiaCFEXService.emitCopiaCertificadoFitosanitario(model).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinnerEmitir = false;
            this.habilitarEmitir = false;
            this.ngOnInit();
        });
    }

    printCopia() {
        this.visibilitySpinnerImprimir = true;
        this.copiaCFEXService.getCertificadoFitosanitarioCopia(this.selectedCopiaCertificadoEx.Id).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinnerImprimir = false;
        });
    }

    anularCopia() {
        this.visibilitySpinnerAnular = true;

        let model: AuxEnvioExViewModel = new AuxEnvioExViewModel();
        model.IdSolicitudEx = this.selectedCopiaCertificadoEx.IdSolicitudEx;
        model.IdCopia = this.selectedCopiaCertificadoEx.Id;
        model.IdUsuario = this.loggedInUser!.Id;
        model.IdIdioma = this.solicitudCopiaCertificadoEx.IdIdioma;

        this.copiaCFEXService.anularCopiaCertificadoFitosanitario(model).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinnerAnular = false;
            this.habilitarAnular = false;
            this.ngOnInit();
        });
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.visibilitySpinner = false;
            this.addErrorMessage('Revise los datos de la copia');

            this.isCollapsedDatosBasicos = false;

            return;
        }

        let copiaCertificadoEx = new CopiaCertificadoExViewModel();

        copiaCertificadoEx.IdSolicitudEx = this.IdSolicitudEx;
        copiaCertificadoEx.IdTipoSolicitudCopiaEx = this.form.value.IdTipoSolicitudCopiaEx;
        copiaCertificadoEx.Observaciones = this.form.value.Observaciones;

        if (this.editMode) {
            copiaCertificadoEx.Id = this.selectedCopiaCertificadoEx.Id;

            this.ManageEstadoCopia(copiaCertificadoEx);

            this.copiaCFEXService.editCopia(copiaCertificadoEx).subscribe({
                next: () => {
                    this.addSuccessMessage('Copia modificada correctamente');

                    if (this.isInspector) {
                        this.ngOnInit();
                    } else {
                        this.onBack();
                    }

                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        } else {
            this.copiaCFEXService.createCopia(copiaCertificadoEx).subscribe({
                next: () => {
                    this.addSuccessMessage('Copia creada correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.isCollapsedDatosBasicos = false;
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    onBack() {
        //this.router.navigate(["/importacion/solicitud/productos", this.IdSolicitud])
        //Usamos el location ya que hay diferentes formas de llegar aquí­
        this._location.back();
    }

    get editTitle(): string {
        if (this.editMode) {
            return 'Editar';
        } else {
            /* Nueva, si viene idCopia en ruta, o Consultar si no*/
            if (this.activatedRoute.snapshot.params['idCopia']) {
                return 'Consultar';
            }
        }
        return 'Nueva';
    }
}
